import IsLoadingHOC from "../Componentes/Loader/IsLoadingHOC";

export const getComponentWithLoading = (wrappedComponent) => { 
  return IsLoadingHOC(wrappedComponent);
};
